import jquery from 'jquery';
import wwdev from '@wwdev/functions';
import * as bootstrap from 'bootstrap';

window.$ = window.jQuery = window.jquery = jquery;
window.wwdev = wwdev;
window.bootstrap = bootstrap;

$.ajaxSetup({
	headers: {
		'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
	}
});

window.showLoader = () => {
	// Dit is toegevoegd zodat de loader niet direct wordt getoond.
	// Dit is namelijk erg vervelend als de request niet lang duurt.
	window.loaderTimeout ? clearTimeout(window.loaderTimeout) : null;
	window.loaderTimeout = setTimeout(() => {
		$('.global-loader').removeClass('d-none');
	}, 300)
}

window.hideLoader = () => {
	window.loaderTimeout ? clearTimeout(window.loaderTimeout) : null;
	$('.global-loader').addClass('d-none');
}